import { stringify } from 'qs';
import { fetchSalesChannel } from 'src/components/SalesChannel/Util';
import { i18n } from 'src/i18n';
import { getField } from 'src/utils/EntryUtil';
import { Environment } from 'src/utils/Environment';

export const SHOPLESS_RESELLER_ID = 'SHOPLESS';

export type ChannelInfo = {
  chainAgent?: string;
  salesforcePartnerId?: string;
};

export async function getDefaultOrResellerChannelInfo(resellerId?: string, chainAgent?: string) : Promise<ChannelInfo | undefined> {
  if (!resellerId) {
    return getDefaultChannelInfo(chainAgent);
  } else {
    return getChannelInfo(resellerId, chainAgent);
  }
}

export async function getDefaultChannelInfo(chainAgent?: string) {
  return fetchSalesChannel(i18n.language, Environment.current.hostname)
  .then(response => {
    const resellerId = getField(response, 'cloverResellerId');
    if (!resellerId) return { chainAgent, salesforcePartnerId: undefined };

    return getChannelInfo(resellerId, chainAgent);
  });
}

export async function getChannelInfo(resellerId: string, chainAgent?: string, cosApiClient = Environment.current.cosApiClient) {
  if (resellerId === SHOPLESS_RESELLER_ID) return undefined;

  const requestQueryParams = {
    requestedAgentId: chainAgent || undefined,
  };
  return cosApiClient
    .get<ChannelInfo>(`/v3/shop/resellers/${resellerId}/chain_agent_id${stringify(requestQueryParams, { addQueryPrefix: true })}`)
    .then(response => {
      const { chainAgent, salesforcePartnerId } = response.data;
      return { chainAgent, salesforcePartnerId };
    })
    .catch(() => {
      console.error(`Failed to get chain agent id from server for resellerId ${resellerId}`);
      return undefined;
    });
}
